import { render, staticRenderFns } from "./bothPublic.vue?vue&type=template&id=0f48aa41"
import script from "./bothPublic.vue?vue&type=script&lang=js"
export * from "./bothPublic.vue?vue&type=script&lang=js"
import style0 from "./bothPublic.vue?vue&type=style&index=0&id=0f48aa41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports